import { render, staticRenderFns } from "./nshop-order-list-method.vue?vue&type=template&id=4fb6a39b&scoped=true&"
import script from "./nshop-order-list-method.vue?vue&type=script&lang=js&"
export * from "./nshop-order-list-method.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb6a39b",
  null
  
)

export default component.exports